import { useMemo } from 'react'

import type { ImportedInvoiceLineAmounts } from '@features/importedInvoices/types/importedInvoiceLineAmounts'
import type { ImportedInvoiceReviewFormSchema } from '@features/importedInvoices/types/importedInvoiceReviewFormSchema'
import { getImportedInvoiceLineAmounts } from '@features/importedInvoices/utils/getImportedInvoiceLineAmounts'
import { getImportedInvoiceVatRate } from '@features/importedInvoices/utils/getImportedInvoiceVatRate'
import { useTaxRates } from '@modules-deprecated/app/taxrates'

import { useFormContext, useWatch } from '../../../../../../../../../../../hooks/useForm'

interface UseImportedInvoiceReviewLineAmountsOptions {
  currency: string | null
  lineIndex: number
}

/** A line is calculated from its amount and VAT rate, and shows no VAT amount until the tax rates have loaded. */
export const useImportedInvoiceReviewLineAmounts = ({
  currency,
  lineIndex,
}: UseImportedInvoiceReviewLineAmountsOptions): ImportedInvoiceLineAmounts => {
  const { control } = useFormContext<ImportedInvoiceReviewFormSchema>()
  const [amountExclVat, vatRateId] = useWatch({
    control,
    name: [`lines.${lineIndex}.amountExclVat`, `lines.${lineIndex}.vatRateId`],
  })
  const { taxRatesIncludingDeactivated } = useTaxRates()

  return useMemo(
    () =>
      getImportedInvoiceLineAmounts({
        amountExclVat,
        currency,
        vatRate: getImportedInvoiceVatRate(taxRatesIncludingDeactivated, vatRateId),
      }),
    [amountExclVat, currency, taxRatesIncludingDeactivated, vatRateId],
  )
}
